import { render, staticRenderFns } from "./PostExample.vue?vue&type=template&id=0d134514&scoped=true"
import script from "./PostExample.vue?vue&type=script&lang=js"
export * from "./PostExample.vue?vue&type=script&lang=js"
import style0 from "./PostExample.vue?vue&type=style&index=0&id=0d134514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d134514",
  null
  
)

export default component.exports